import script from "./HrEmptyState.vue?vue&type=script&setup=true&lang=js"
export * from "./HrEmptyState.vue?vue&type=script&setup=true&lang=js"

import "./HrEmptyState.vue?vue&type=style&index=0&id=64c80b7b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64c80b7b"]])

export default __exports__